'use client';

import FacebookPixel from './facebook-pixel';

interface AnalyticsProviderProps {
  fbq: string;
}

export default function AnalyticsProvider({ fbq }: AnalyticsProviderProps) {
  return <FacebookPixel fbq={fbq} />;
}
